import { API } from "../../../utils";

export const getUbereatsList = async () => {
  const res = await API.get(`ubereats/stores`);
  return res.data;
};
export const uploadAllMenu = async (intID) => {
  const res = await API.get(`integrations/${intID}/menu_upload`);
  return res;
};
export const uploadPushMenu = async (intID, id) => {
  const res = await API.get(`integrations/${intID}/stores/${id}/menu_upload`);
  return res;
};
export const editUbereats = async (payload) => {
  const res = await API.put(`ubereats/stores`, payload);
  return res.data;
};



